import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export type HomeBanner = {
  id: number;
  title: string;
  buttonName: string;
  mobileImageUrl: string;
  mobileLinkUrl: string;
  pcImageUrl: string;
  pcLinkUrl: string;
};

export const homeBannerUrl = '/api/citizen/v1/home/banners';

export const getHomeBanner = async () => {
  const { data } = await axios.get<HomeBanner[]>(homeBannerUrl);
  return data;
};

export const useHomeBanners = (options?: UseDosiminQueryOptions<HomeBanner[]>) =>
  useQuery<HomeBanner[]>({
    queryKey: ['home', 'banner'],
    queryFn: getHomeBanner,
    initialData: [],
    ...options,
  });
